import React from "react";
import styles from "./Contact.module.css";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.contact}>
      <div className={styles.container}>
        <h1 className={styles.title}>Ready to see us in action?</h1>
        <p className={styles.subtitle}>
          Schedule a demo and see how Galile can help you close more deals, faster
        </p>
        <div className={styles.ctaContainer}>
          <a
            href="https://calendly.com/viraj-galile/30min"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className={styles.primaryButton}>Book a Demo</button>
          </a>
          <button onClick={(e) => {e.preventDefault(); e.stopPropagation(); console.log('Navigating to contact'); navigate('/contact');}} className={styles.secondaryButton}>Contact Us</button>
        </div>
      </div>
    </section>
  );
};

export default Contact;